/* eslint-disable no-underscore-dangle */

import EventEmitter from 'events';

import createCounter from '../createCounter';
import logging from '../../ot/logging';
import LoggerFactory, { pipeToLogger } from '../Logger';
import ReconnectableSocketFactory from '../ReconnectableSocket';
import RumorSocketFactory from '../rumor/RumorSocket';
import WebSocketImport from './WebSocket';

export default function defaultRumorSocket({ WebSocket = WebSocketImport } = {}) {
  const allocateId = createCounter();

  const Logger = LoggerFactory(pipeToLogger(logging));

  const ReconnectableSocket = ReconnectableSocketFactory({
    EventEmitter,
    WebSocket,
    Logger,
    allocateId,
  });

  const RumorSocket = RumorSocketFactory({
    EventEmitter,
    ReconnectableSocket,
    Logger,
    allocateId,
  });

  if (WebSocket.instances) {
    // For raptor's minimally ported tests, remove when possible
    RumorSocket.webSockets = WebSocket.instances;
  }

  return RumorSocket;
}



// WEBPACK FOOTER //
// ./src/js/RaptorSession/raptor/defaultRumorSocket.js